export const Chip = 'atlantis-chip';
export const StatusChip = 'atlantis-status-chip';